import React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatINR, formatNum } from "@/lib/api";
import { STATUS_LABEL, STATUS_STYLE, purityFactor } from "@/pages/admin/jobwork/jobWorkHelpers";

export const JobsTable = ({ jobs, onOpenDetail }) => (
  <Card className="overflow-hidden">
    <div className="overflow-x-auto">
      <Table data-testid="jobs-table">
        <TableHeader><TableRow className="bg-[#F4EBDD]">
          <TableHead>Job #</TableHead><TableHead>Date</TableHead><TableHead>Karigar</TableHead><TableHead>Design</TableHead>
          <TableHead className="text-right">Gold Issued (fine g)</TableHead><TableHead className="text-right">Making (₹)</TableHead><TableHead>Status</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {jobs.map((j) => (
            <TableRow key={j.id} className="hover:bg-[#F7F0E6] cursor-pointer" onClick={() => onOpenDetail(j)}>
              <TableCell className="font-mono text-sm">{j.job_no}</TableCell>
              <TableCell className="text-sm">{j.job_date}</TableCell>
              <TableCell>{j.karigar_name}</TableCell>
              <TableCell className="text-sm">{j.product_ref}</TableCell>
              <TableCell className="text-right font-mono">{j.gold ? formatNum((j.gold.net_weight_g || 0) * purityFactor(j.gold.purity, j.gold.purity_fine_pct)) : "-"}g</TableCell>
              <TableCell className="text-right font-mono">{formatINR(j.making_charges)}</TableCell>
              <TableCell><Badge className={STATUS_STYLE[j.status]}>{STATUS_LABEL[j.status]}</Badge></TableCell>
            </TableRow>
          ))}
          {jobs.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-10 text-muted-foreground">No job work orders yet. Create one to send material to a karigar.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  </Card>
);
